<template>
    <div>
        <PassportUploadComment v-if="(commentPosition === 'before') && !compactMode"/>

        <p v-if="uploaded && showUploadedComment">
            <small class="text-success">Скан паспорта загружен. <a href="#" v-if="compactMode" @click.prevent="compactModeOffByUser = true">Загрузить повторно?</a></small>
        </p>

        <p v-if="verified && showUploadedComment">
            <small class="text-success">Паспортные данные проверены.</small>
        </p>

        <div class="form-group input-group-sm" v-if="!compactMode">
            <button type="button" class="btn btn-info btn-sm" @click="loadPhoto">{{ uploaded ? 'Загрузить скан паспорта повторно' : 'Загрузить скан паспорта' }}</button>
            <input
              type="file"
              style="display: none;"
              ref="photoFileInput"
              accept="image/*,application/pdf"
              @change="upLoad"
            />
        </div>
        <PassportUploadComment v-if="(commentPosition === 'after') && !compactMode"/>
    </div>
</template>
<script>

import PassportUploadComment from '@/components/passportUploadComment.vue'

export default {
    props: {
        commentPosition: {
            type: String,
            default: 'after',
        },
        showUploadedComment: {
            type: Boolean,
            default: true
        }
    },
    data() {
        return {
            compactModeOffByUser: false,
        }
    },
    computed: {
        verified() {
            return this.$store.getters.getUserData.memberInfo?.isPassportDataVerified;
        },
        uploaded() {
            return this.$store.getters.getUserData.memberInfo?.isPassportScanUploaded;
        },
        compactModePossible() {
            return this.uploaded && this.showUploadedComment;
        },
        compactMode() {
            return this.compactModePossible && !this.compactModeOffByUser;
        },
    },
    components: {
        PassportUploadComment
    },
    methods: {
        loadPhoto() {
            this.$refs.photoFileInput.click()
        },
        upLoad(event) {
            const input = event.target;
            if (input.files && input.files[0]) {
                const data = new FormData();
                data.append('passport', input.files[0], input.files[0].name);
                this.$store.dispatch('savePassportScan', data);
            }
        }
    },
    watch: {
        uploaded(v) {
            if (v && this.showUploadedComment) {
                this.compactMode = true;
            }
        }
    }
}
</script>
